import React from 'react'
import './Item.css'
import { Link } from 'react-router-dom'
import placeholderImg from '../Assets/placeholder-256x256px.png'

const Item = (props) => {

  const image = props.images?.[0] ?? props.image ?? placeholderImg
  const isOnSale = props.old_price && props.price && props.old_price > props.price
  const isOutOfStock = props.available === false
  const discount = props.discount_percentage > 0 ? Math.round(props.discount_percentage) : null

  return (
    //new one
    <Link to={`/product/${props.id}`} className='item-link' onClick={() => window.scrollTo(0, 0)}>
      <div className={`item ${isOutOfStock ? 'item--out-of-stock' : ''}`}>
        <div className='item-img-wrap'>
          <img src={image} alt={props.name} />

          {/* Discount percentage badge - top left, inside image */}
          {discount && (
            <span className='item-discount-badge'>−{discount}%</span>
          )}

          {/* Out of stock - top right label always visible */}
          {isOutOfStock && (
            <span className='item-oos-badge'>Out of Stock</span>
          )}

          {/* Out of stock - overlay shown on hover */}
          {isOutOfStock && (
            <div className='item-oos-overlay'>
              <span className='item-oos-overlay-text'>Out of Stock</span>
            </div>
          )}
        </div>

        <div className='item-information'>
          {isOnSale ? <span className='item-badge'>Sale</span> : <span className='item-badge-none'></span>}
          <p className='item-name'>{props.name}</p>
          <div className='item-prices'>
            <span className='item-price-new'>Rs. {props.price}</span>
            {props.old_price && (
              <span className='item-price-old'>Rs. {props.old_price}</span>
            )}
          </div>
        </div>
      </div>
    </Link>

  )
}

export default Item